import './filter-section.scss';
import { SeeMorePager } from './see-more-pager';

/**
 * version    1.0
 * class      <type> (filter section)
 * classdesc  Main filter section
 */

export class FilterSection {
  constructor(blocksFondiInstance) {
    this.blocksFondi = blocksFondiInstance;
    this.buttons = document.querySelectorAll('.tab-button');
    this.cards = document.querySelectorAll('.news-card');
    this.spotlightSlides = document.querySelectorAll('.spotlight-slider');
    this.fondi = document.querySelectorAll('.blocks-fondi__card');
    this.portfolioCards = document.querySelectorAll('.blocks-portfolio__card-wrapper');
    this.portfolioFilters = document.querySelectorAll('.option-portfolio-wrapper select');
    this.dateSelect = document.getElementById('date-select');
    this.activeFilter = null;
    this.toggleButton = document.getElementById('filtro-fase');
    this.optionWrapper = document.getElementById('option-fase-wrapper');
    this.faseCheckboxes = document.querySelectorAll('.fase-checkbox');
    this.exclusiveFilters = ['InvestimentoDiretto', 'FondiSupportati'];

    this.filterConfig = {
      categoria: {
        param: 'category',
        value: () => this.activeFilter,
        matches: (cardVal, filterVal) => !filterVal || cardVal.split(',').includes(filterVal),
      },
      date: {
        param: 'date',
        value: () => (
          this.dateSelect ? this.dateSelect.value : ''
        ),
        matches: (cardVal, filterVal) => !filterVal || cardVal === filterVal,
      },
      fase: {
        param: 'fase',
        value: () => $('#fase').val(),
        matches: (cardVal, filterVal) => !filterVal || cardVal === filterVal,
      },
      veicolo: {
        param: 'veicolo',
        value: () => $('#veicolo').val(),
        matches: (cardVal, filterVal) => !filterVal || cardVal === filterVal,
      },
      settore: {
        param: 'settore',
        value: () => $('#settore').val(),
        matches: (cardVal, filterVal) => !filterVal || cardVal === filterVal || cardVal.split(',').map((s) => s.trim()).includes(filterVal),
      },
      regione: {
        param: 'regione',
        value: () => $('#regione').val(),
        matches: (cardVal, filterVal) => !filterVal || cardVal === filterVal,
      },
    };

    this.pager = new SeeMorePager({
      itemsPerPage: 6,
      containerSelector: '#pagination-items',
      buttonSelector: '.see-more-pager__button',
    });

    this.init();
    this.loadFiltersFromURL();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.getAttribute('data-filter');

        const isExclusive = this.exclusiveFilters.includes(filter);

        if (this.activeFilter === filter) {
          // Deseleziona il filtro esclusivo
          this.activeFilter = null;
          button.classList.remove('active');
        } else {
          this.activeFilter = filter;
          this.updateButtonStates(button);

          if (isExclusive) {
            // Resetta tutti gli altri select e checkbox
            this.resetOtherFilters();
          }
        }

        this.applyFilters();
        this.updateURL();
        this.updateVisibleFilters(this.activeFilter);
      });
    });

    if (this.dateSelect) {
      this.dateSelect.addEventListener('change', () => {
        this.applyFilters();
        this.updateURL();
      });
    }

    if (this.portfolioFilters) {
      this.portfolioFilters.forEach((select) => {
        select.addEventListener('click', function () {
          if (!this.classList.contains('select-open')) {
            this.classList.add('select-open');
          }
        });

        document.addEventListener('click', (e) => {
          if (!select.contains(e.target)) {
            select.classList.remove('select-open');
          }
        });

        select.addEventListener('change', () => {
          this.applyFilters();
          this.updateURL();
        });
      });
    }

    if (this.toggleButton && this.optionWrapper) {
      this.toggleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleButton.classList.toggle('active');
        this.optionWrapper.classList.toggle('active');
      });

      document.addEventListener('click', (e) => {
        if (!this.optionWrapper.contains(e.target) && !this.toggleButton.contains(e.target)) {
          this.toggleButton.classList.remove('active');
          this.optionWrapper.classList.remove('active');
        }
      });
    }

    this.faseCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.applyFilters();
        this.updateRecapFase();
      });
    });
  }

  updateButtonStates(activeButton) {
    this.buttons.forEach((btn) => btn.classList.remove('active'));
    if (activeButton && this.activeFilter) {
      activeButton.classList.add('active');
    }
  }

  applyFilters() {
    const selectedFasi = Array.from(this.faseCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.id);

    // Filtro news-card
    this.applyFiltersToCards(this.cards, {
      categoria: 'data-category',
      date: 'data-date',
    });

    // Filtro spotlight
    this.applyFiltersToCards(this.spotlightSlides, {
      categoria: 'data-category',
      date: 'data-date',
      fase: 'data-fase',
    });

    // Filtro portfolio
    this.applyFiltersToCards(this.portfolioCards, {
      categoria: 'data-category',
      fase: 'data-fase',
      veicolo: 'data-veicolo',
      settore: 'data-settore',
      regione: 'data-regione',
    });

    // Filtro fondi
    this.applyFiltersToCards(this.fondi, {
      categoria: 'data-category',
      fase: 'data-fase',
    }, selectedFasi);

    this.updateRecapFase();
    this.pager.reset();

    // Dopo un piccolo delay, riallinea Masonry
    if (this.blocksFondi && this.blocksFondi.msnry) {
      setTimeout(() => {
        this.blocksFondi.reloadItems();
        this.blocksFondi.layout();
      }, 400);
    }
  }

  applyFiltersToCards(cards, attrMap, customFasi = null) {
    const filters = Object.entries(this.filterConfig).reduce((acc, [key, conf]) => {
      acc[key] = conf.value();
      return acc;
    }, {});

    cards.forEach((card) => {
      const matches = Object.entries(attrMap).every(([filterKey, attrName]) => {
        const cardVal = card.getAttribute(attrName) || '';
        const filterVal = filters[filterKey];

        // gestione custom per checkbox fase multiple
        if (filterKey === 'fase' && customFasi) {
          const cardFasi = cardVal.split(',').map((f) => (f).trim());
          return customFasi.length === 0 || customFasi.some((f) => cardFasi.includes(f));
        }

        return this.filterConfig[filterKey].matches(cardVal, filterVal);
      });

      if (matches) {
        // Mostra card
        card.classList.remove('is-hidden', 'is-hiding');
        card.classList.add('is-visible');

        // Solo se non sono fondi, rimuovi anche "filtered-out"
        if (!card.classList.contains('blocks-fondi__card')) {
          card.classList.remove('filtered-out');
        }
      } else {
        // Nascondi con transizione
        card.classList.remove('is-visible');
        card.classList.add('is-hiding');

        // Solo se non sono fondi, aggiungi "filtered-out"
        if (!card.classList.contains('blocks-fondi__card')) {
          card.classList.add('filtered-out');
        }

        // Dopo la transizione, display:none
        setTimeout(() => {
          card.classList.add('is-hidden');
          if (this.blocksFondi && this.blocksFondi.msnry) {
            this.blocksFondi.reloadItems();
            this.blocksFondi.layout();
          }
        }, 350);
      }
    });
  }

  updateVisibleFilters(filter) {
    const filterVisibilityMap = {
      fase: [],
      veicolo: ['FondiSupportati'],
      settore: ['InvestimentoDiretto'],
      regione: ['InvestimentoDiretto'],
    };

    const filterWrappers = document.querySelectorAll('.option-portfolio');
    filterWrappers.forEach((wrapper) => {
      const key = wrapper.getAttribute('data-filter-key');
      if (!filter || (filterVisibilityMap[key] && filterVisibilityMap[key].includes(filter))) {
        wrapper.classList.remove('hidden');
      } else {
        wrapper.classList.add('hidden');
      }
    });
  }

  resetOtherFilters() {
    // Reset dropdown/select
    this.portfolioFilters.forEach((select) => {
      const currentSelect = select;
      currentSelect.value = '';
    });

    // Reset date select
    if (this.dateSelect) {
      this.dateSelect.value = '';
    }

    // Reset fase checkboxes
    this.faseCheckboxes.forEach((checkbox) => {
      const cb = checkbox;
      cb.checked = false;
    });

    // Se necessario aggiungere altri reset qui
  }

  loadFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');
    const date = params.get('date');

    if (category) {
      this.activeFilter = category;
      const button = document.querySelector(`.tab-button[data-filter="${category}"]`);
      if (button) this.updateButtonStates(button);
      this.updateContainerCategoryClass();
    }

    if (date && this.dateSelect) {
      this.dateSelect.value = date;
    }

    this.applyFilters();
    this.updateVisibleFilters(this.activeFilter);
  }

  updateContainerCategoryClass() {
    const container = document.querySelector('.filter-section__container');
    if (!container) return;

    container.classList.forEach((cls) => {
      if (cls.startsWith('category-')) {
        container.classList.remove(cls);
      }
    });

    if (this.activeFilter) {
      container.classList.add(`category-${this.activeFilter}`);
    }
  }

  updateURL() {
    const params = new URLSearchParams();
    if (this.activeFilter) params.set('category', this.activeFilter);
    if (this.dateSelect && this.dateSelect.value) {
      params.set('date', this.dateSelect.value);
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }

  updateRecapFase() {
    const recapContainer = document.getElementById('recap-fase');
    const toggleFiltro = document.getElementById('filtro-fase');

    const selectedCheckboxes = Array.from(document.querySelectorAll('.fase-checkbox:checked'));
    const selectedLabels = selectedCheckboxes.map((cb) => cb.getAttribute('data-fase-label'));
    const hasSelections = selectedLabels.length > 0;

    if (recapContainer) {
      recapContainer.innerHTML = '';

      const title = document.createElement('p');
      title.textContent = 'Fase:';
      recapContainer.appendChild(title);

      selectedLabels.forEach((label) => {
        const p = document.createElement('p');
        p.classList.add('fase-tag');
        p.textContent = label;
        recapContainer.appendChild(p);
      });

      recapContainer.classList.toggle('active', hasSelections);
    }

    if (toggleFiltro) {
      toggleFiltro.classList.toggle('has-active-filter', hasSelections);
    }
  }
}
